import ProjectBrowsePodsBarComponent from './project-browse-pods-bar.component'

export default ProjectBrowsePodsBarComponent
